export const SITE_URL = 'https://game4git.com';
export const SITE_NAME = 'Game4Git';
